import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/Home/HomePage.vue";
import HomeLandingPage from "../views/Home/HomeLandingPage.vue";
import CategoriesPage from "../views/CategoriesPage.vue";
import SubjectsPage from "../views/SubjectsPage.vue";
import SubjectDetailPage from "../views/SubjectDetailPage.vue";
import AgentSquare from "../views/AgentSquare.vue";
import AgentChat from "../views/AgentChat.vue";
import ExplorePage from "../views/ExplorePage.vue";
import RankingsPage from "../views/RankingsPage.vue";
import LoginPage from "../views/LoginPage.vue";
import RegisterPage from "../views/RegisterPage.vue";
import SubmitToolPage from "../views/SubmitToolPage.vue";
import SubmitRequestPage from "../views/SubmitRequestPage.vue";
import ToolRequestsPage from "../views/ToolRequestsPage.vue";
import CaseSquarePage from "../views/CaseSquarePage.vue";
import CreateSquarePage from "../views/CreateSquarePage.vue";
import SoftwarePage from "../views/SoftwarePage.vue";
import SubmitCasePage from "../views/SubmitCasePage.vue";
import WebInfoPage from "../views/WebInfoPage.vue";
import PromptPage from "../views/PromptPage.vue";
import PlayPage from "../views/PlayPage.vue";
import ToolPage from "../views/ToolPage.vue";
import AdminPage from "../views/admin/AdminPage.vue";
import UserCenterPage from "../views/UserCenterPage.vue";
import WorkbenchPage from "../views/WorkbenchPage.vue";
import WorkbenchRunPage from "../views/WorkbenchRunPage.vue";
import MessagesPage from "../views/MessagesPage.vue";
import DataAnalysisPage from "../views/DataAnalysisPage.vue";
import axios from "../utils/axios";
import store from "../store/index";

const routes = [
  {
    // 首页：仅首屏介绍区（标题 / 入口按钮 / 小义问宝 / 词云轮播）
    path: "/",
    name: "Home",
    component: HomeLandingPage,
    meta: { title: "首页" },
  },
  {
    // 应用广场：工具 / 智能体 / 案例 / 网站 / 软件 / 提示词 / 需求等板块聚合页
    path: "/square",
    name: "Square",
    component: HomePage,
    meta: { title: "AI应用广场" },
  },
  {
    path: "/user",
    name: "UserCenter",
    component: UserCenterPage,
    meta: {
      requiresAuth: true,
      title: "我的AI工作台", // 板块二
    },
  },
  {
    // 我的 HTML 工作台：导入自定义 HTML，站内 iframe 打开，数据按账号隔离
    path: "/workbench",
    name: "Workbench",
    component: WorkbenchPage,
    meta: { requiresAuth: true, title: "我的 HTML 工作台" },
  },
  {
    // 运行态：整屏渲染某个工作台
    path: "/workbench/run/:id",
    name: "WorkbenchRun",
    component: WorkbenchRunPage,
    meta: { title: "工作台" },
  },
  {
    path: "/agents",
    name: "Agents",
    component: AgentSquare,
    meta: { title: "AI 智能体 - AI工具集市" },
  },
  {
    path: "/agent/:id",
    name: "AgentChat",
    component: AgentChat,
    meta: { title: "智能体对话 - AI工具集市" },
  },
  {
    path: "/analysis",
    name: "DataAnalysis",
    component: DataAnalysisPage,
    meta: { title: "小义AI科学分析台 - AI工具集市" },
  },
  {
    path: "/subject/:id",
    name: "SubjectDetail",
    component: SubjectDetailPage,
    meta: { title: "学科工具体系 - AI工具集市" },
  },
  {
    path: "/categories",
    name: "Categories",
    component: CategoriesPage,
    meta: { title: "分类导航 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/subjects",
    name: "Subjects",
    component: SubjectsPage,
    meta: { title: "学科导航 - AI工具集市" },
  },
  {
    path: "/explore",
    name: "Explore",
    component: ExplorePage,
    meta: { title: "发现工具 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/rankings",
    name: "Rankings",
    component: RankingsPage,
    meta: { title: "工具排行 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/submit",
    name: "SubmitTool",
    component: SubmitToolPage,
    meta: { title: "工具YI起搓 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/request",
    name: "SubmitRequest",
    component: SubmitRequestPage,
    meta: { title: "提出需求 - AI工具集市" },
  },
  {
    path: "/requests",
    name: "ToolRequests",
    component: ToolRequestsPage,
    meta: { title: "问题YI起解 - AI工具集市" },
  },
  {
    path: "/cases",
    name: "CaseSquare",
    component: CaseSquarePage,
    meta: { title: "应用场景案例 - AI工具集市" },
  },
  {
    // 板块三：AI创想广场（教师创作与需求聚合）
    path: "/create",
    name: "CreateSquare",
    component: CreateSquarePage,
    meta: { title: "AI创想广场" },
  },
  {
    path: "/software",
    name: "SoftwareShare",
    component: SoftwarePage,
    meta: { title: "软件分享 - AI工具集市" },
  },
  {
    path: "/cases/submit",
    name: "SubmitCase",
    component: SubmitCasePage,
    meta: { title: "投稿案例 - AI工具集市" },
  },
  {
    path: "/webinfo",
    name: "WebInfo",
    component: WebInfoPage,
    meta: { title: "网页YI起建 - AI工具集市" },
  },
  {
    path: "/prompts",
    name: "Prompts",
    component: PromptPage,
    meta: { title: "提示词分享 - AI工具集市" },
  },
  {
    path: "/play/:id",
    name: "Play",
    component: PlayPage,
    meta: { title: "在线互动 - AI工具集市" },
  },
  {
    // 工具专属页面：分享链接 https://xxx/tool/工具id 直接打开（不登录也可浏览）
    path: "/tool/:id",
    name: "Tool",
    component: ToolPage,
    meta: { title: "工具详情 - AI工具集市" },
  },
  {
    path: "/admin",
    name: "Admin",
    component: AdminPage,
    meta: {
      title: "管理后台 - AI工具集市",
      requiresAuth: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/messages",
    name: "Messages",
    component: MessagesPage,
    meta: { title: "消息中心 - AI工具集市" },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
    meta: { title: "登录 - AI工具集市" }, // 添加页面标题
  },
  {
    path: "/register",
    name: "Register",
    component: RegisterPage,
    meta: { title: "注册 - AI工具集市" }, // 添加页面标题
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 导航守卫 - 前置守卫（这里可以保留你后续的鉴权逻辑）
router.beforeEach((to, from, next) => {
  const searchParams = new URLSearchParams(window.location.search);
  var ticket = searchParams.get("ticket") || null;
  if (ticket) {
    axios({
      url: "user/author/login",
      method: "POST",
      data: {
        ticket: ticket,
      },
    }).then((res) => {
      if (res.code == 200) {
        var user = res.data;
        localStorage.setItem("token", user.token);
        store.commit("setUserInfo", user);
      }
      next();
    });
  } else {
    next();
  }
  // 你可以在这里添加登录鉴权逻辑，比如判断 requiresAuth
  // if (to.meta.requiresAuth) {
  //   // 示例：检查用户是否登录
  //   const isLogin = localStorage.getItem("token"); // 假设用localStorage存储登录状态
  //   if (!isLogin) {
  //     // 未登录则跳转到登录页
  //     next({ name: "Login" });
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
});

// 导航守卫 - 后置守卫：设置页面标题
router.afterEach((to) => {
  // 统一品牌后缀：页面名 - 小义AI教育工具平台
  // 兼容各路由 meta.title 里已带 " - AI工具集市" 的旧写法，先去掉再统一拼接
  let pageTitle = (to.meta.title || "")
    .replace(/\s*-\s*(小义)?AI工具集市\s*$/, "")
    .trim();
  if (!pageTitle || pageTitle === "AI工具集市") pageTitle = "首页";
  document.title = pageTitle + " - 小义AI教育工具平台";
});

export default router;
